// Mapping of workspace names to their deficiency route IDs and back navigation routes
export const WORKSPACE_DEFICIENCY_ROUTES: Record<
  string,
  { routeId: string; backRoute: string }
> = {
  "Employee Benefits Expense": {
    routeId: "payroll-deficiencies",
    backRoute: "execution-payroll",
  },
  "Property, Plant & Equipment": {
    routeId: "ppe-deficiencies",
    backRoute: "execution-ppe",
  },
  "Intangible Assets": {
    routeId: "ia-deficiencies",
    backRoute: "execution-ia",
  },
  "Trade Payables": {
    routeId: "trdpbl-deficiencies",
    backRoute: "execution-trade-payables",
  },
  "Trade Receivables": {
    routeId: "trdrcv-deficiencies",
    backRoute: "execution-trade-receivables",
  },
  "Depreciation": {
    routeId: "depr-deficiencies",
    backRoute: "execution-depreciation",
  },
  "Other Assets": {
    routeId: "othas-deficiencies",
    backRoute: "execution-other-assets",
  },
  "Other Financial Assets": {
    routeId: "ofa-deficiencies",
    backRoute: "execution-other-financial-assets",
  },
  "Other Income": {
    routeId: "othinc-deficiencies",
    backRoute: "execution-other-income",
  },
  "Revenue from Operations": {
    routeId: "rfo-deficiencies",
    backRoute: "execution-rfo",
  },
  Inventory: {
    routeId: "inv-deficiencies",
    backRoute: "execution-inv",
  },
  "Cash & Cash Equivalents": {
    routeId: "cce-deficiencies",
    backRoute: "execution-cce",
  },
  "Finance Costs": {
    routeId: "fincst-deficiencies",
    backRoute: "execution-finance-cost",
  },
  "Income Tax": {
    routeId: "inctx-deficiencies",
    backRoute: "execution-income-tax",
  },
  Investments: {
    routeId: "invsmt-deficiencies",
    backRoute: "execution-investments",
  },
  "Provisions and Contingent Liabilities": {
    routeId: "pcl-deficiencies",
    backRoute: "execution-pcl",
  },
  "Lease Liability": {
    routeId: "llas-deficiencies",
    backRoute: "execution-lease-liability",
  },
  "Lease Liability - Ind AS": {
    routeId: "ll-deficiencies",
    backRoute: "execution-lease-liability-ind-as",
  },
  "Right-of-Use Assets": {
    routeId: "rou-deficiencies",
    backRoute: "execution-right-of-use-assets",
  },
  "Impairment Testing": {
    routeId: "imp-deficiencies",
    backRoute: "execution-impairment",
  },
  "Other Expenses": {
    routeId: "othexp-deficiencies",
    backRoute: "execution-other-expenses",
  },
  "Other Liabilities": {
    routeId: "othlib-deficiencies",
    backRoute: "execution-other-liabilities",
  },
  "Other Financial Liabilities": {
    routeId: "ofllib-deficiencies",
    backRoute: "execution-other-financial-liabilities",
  },
  "Other Receivables": {
    routeId: "othrec-deficiencies",
    backRoute: "execution-other-receivables",
  },
  "Going Concern": {
    routeId: "golib-deficiencies",
    backRoute: "execution-going-concern",
  },
  "Litigations & Claims": {
    routeId: "litclm-deficiencies",
    backRoute: "execution-litigations-claims",
  },
  "Opening Balance Testing": {
    routeId: "opnbal-deficiencies",
    backRoute: "execution-opening-balance",
  },
  "Related Party Disclosure": {
    routeId: "relpard-deficiencies",
    backRoute: "execution-related-party",
  },
  Equity: {
    routeId: "eqt-deficiencies",
    backRoute: "execution-equity",
  },
  "Management Use of Expert": {
    routeId: "mgtexp-deficiencies",
    backRoute: "execution-management-expert",
  },
  "Use of Auditor's Specialist": {
    routeId: "useadtr-deficiencies",
    backRoute: "execution-auditor-specialist",
  },
  "Compliance with Laws and Regulations": {
    routeId: "cmplr-deficiencies",
    backRoute: "execution-compliance-laws",
  },
  "Review of Estimates for Management Bias": {
    routeId: "rvestmb-deficiencies",
    backRoute: "execution-review-estimates",
  },
  "Internal Audit": {
    routeId: "intadt-deficiencies",
    backRoute: "execution-internal-audit",
  },
  "Cost of Materials Consumed": {
    routeId: "comc-deficiencies",
    backRoute: "execution-comc",
  },
  Borrowings: {
    routeId: "bor-deficiencies",
    backRoute: "execution-borrowings",
  },
  "Finance Cost": {
    routeId: "fincst-deficiencies",
    backRoute: "execution-finance-cost",
  },
  "Financial Closing & Reporting Process": {
    routeId: "fcrp-deficiencies",
    backRoute: "execution-fcrp",
  },
  "Management Override of Controls": {
    routeId: "moc-deficiencies",
    backRoute: "execution-moc",
  },
  "Secretarial Compliance": {
    routeId: "secr-deficiencies",
    backRoute: "execution-secr",
  },
  Incentives: {
    routeId: "inct-deficiencies",
    backRoute: "execution-inct",
  },
  Valuation: {
    routeId: "val-deficiencies",
    backRoute: "execution-val",
  },
  "Contract Assets": {
    routeId: "cona-deficiencies",
    backRoute: "execution-cona",
  },
  "Provisions & Contingent Liabilities": {
    routeId: "pcl-deficiencies",
    backRoute: "execution-pcl",
  },
  "Minutes of Meeting": {
    routeId: "mom-deficiencies",
    backRoute: "concluding-mom",
  },
};

